module.exports = __webpack_public_path__ + "static/media/ct2.4e857f2e.png";